export const DEFAULT_DISTANCE_BETWEEN_BREAKPOINTS = 5;

export type Breakpoints = {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xlg: number;
};

export const breakpoints: Breakpoints = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xlg: 1400
};

export default {
  down: (key: keyof Breakpoints) => `@media (max-width:${breakpoints[key]}px)`,
  up: (key: keyof Breakpoints) =>
    `@media (min-width: ${breakpoints[key] - DEFAULT_DISTANCE_BETWEEN_BREAKPOINTS / 100}px)`
};
